var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 57,
    viewBox: "0 0 68 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#2u7tg97eha)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 10.273c18 0 24 17.982 24 17.982s-6 17.982-24 17.982-24-17.982-24-17.982 6-17.982 24-17.982zm0 5.994c-6.713 0-11.161 3.263-14.14 6.835a26.357 26.357 0 0 0-3.275 5.024l-.064.13.064.128a26.36 26.36 0 0 0 3.274 5.025c2.98 3.571 7.428 6.834 14.141 6.834s11.161-3.263 14.14-6.834a26.354 26.354 0 0 0 3.275-5.025l.064-.129-.064-.129a26.351 26.351 0 0 0-3.274-5.024C45.16 19.53 40.713 16.267 34 16.267zm0 2.997c.922 0 1.812.139 2.65.396a4.496 4.496 0 0 0 1.85 8.595 4.501 4.501 0 0 0 4.103-2.647c.258.837.397 1.726.397 2.647 0 4.966-4.03 8.991-9 8.991s-9-4.025-9-8.99c0-4.966 4.03-8.992 9-8.992z",
    fill: "url(#7yijj5wxzb)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7yijj5wxzb",
    x1: 34,
    y1: 10.273,
    x2: 34,
    y2: 46.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2u7tg97eha",
    x: 0,
    y: 0.273,
    width: 68,
    height: 55.965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.984314 0 0 0 0 0.862745 0 0 0 0 0.611765 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_1131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_121_1131",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d1804efea8b97d065c966508cc9238ab.svg";
export { ForwardRef as ReactComponent };